import resetForm from './resetForm';
import setIsNewRecord from './setIsNewRecord';
import toggleModal from './toggleModal';

export default () => (dispatch) => {
    dispatch(resetForm());
    dispatch(setIsNewRecord(true));
    dispatch(toggleModal(true));
};
